
import { OddsButton } from '@/components/widgets/odds-button';
import { DisplayLineInfo, getDisplayLineInfo } from '@/utils/odds-utils';
import { useTranslations } from 'next-intl';
import { useTimeMachine } from '../../context/time-machine-context';
import { useAccountInfo } from '@/hooks/query/account';
import { Market, SportMatchModel } from '@nf/types/odds';
import { Box } from '@nf/utils-common/fpw/monadic';
import { stringEmptyCheck } from '@nf/utils-common/fpw/utils';
import { useGetBetTypeSetting } from '@/hooks';


export const TimeMachineOddsButton = ({ matchModel, oddsData, betTypeId } :{matchModel: SportMatchModel, oddsData : Market[], betTypeId : number}) => { 
	const getBetTypeSetting = useGetBetTypeSetting();
	const getTranslatedLine = ({ prefixLabel, displayLine }: DisplayLineInfo) => stringEmptyCheck(prefixLabel)
		.fold(
			() => displayLine,
			(label: string) => `${t(label)}${displayLine}`
		);
	const { pointValue } = useTimeMachine();
	const { betChoices } = getBetTypeSetting(betTypeId, matchModel.GameID);
	const t=useTranslations('General');
	const { user } = useAccountInfo();
	const market =oddsData.find(item => Number(item.Resourceid) == pointValue && item.BetTypeId == betTypeId);
	if (!market) return ;
	return (
		betChoices.map((choice) => {

			const line = Box.of({
				line: market.Line,
				betType: market.BetTypeId,
				betTeam: choice.betTeam
			})
				.map(getDisplayLineInfo)
				.map(getTranslatedLine)
				.extract();

			return 	market ? 
				<OddsButton
					key={`TimeMachine_${market?.BetTypeId}_${market.Selections[choice.betTeam].SelId}_${pointValue}}`}
					match={matchModel}
					market={market}
					selection={market.Selections[choice.betTeam]}
					homeTeamName={''}
					awayTeamName={''}
					goal={line}
					betTeam={market.Selections[choice.betTeam].SelId}
					originalPrice={market.Selections[choice.betTeam].Price}
					sport={matchModel?.GameID}
					type="OU"
					oddsType={user?.OType}
					variant="center"
					title={t(choice.label)}
					accountStatus={user?.ActStatus ?? 0}
				/> : null
		
		})

	)
}